import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CatBreeds, DogBreeds } from "services/rest/breedsApi";
import logger from "common/utilities/logger";
import FormStep1 from "./step1";
import FormStep2 from "./step2";
import FormStep3 from "./step3";
import FormStep4 from "./step4";
import Header from "components/header";
import Footer from "components/footer";
import FormStep5 from "./step5";
import FormStep6 from "./step6";
import FormStep7 from "./step7";

const ConversationalForm = () => {
    const { sdkConfig } = useSelector((state) => state.userDetails);

    const [formData, setFormData] = useState({
        petType: "DOG",
        firstName: "",
        lastName: "",
        breedId: "",
        petName: "",
        petAge: "",
        email: "",
        zipCode: "",
        marketing: true,
        isValidZip: false,
        isValidEmail: false,
    });

    const [stepNo, setStepNo] = useState(1);
    const [dogBreedsData, setDogBreedsData] = useState([]);
    const [catBreedsData, setCatBreedsData] = useState([]);
    const [inProcess, setInProcess] = useState(false);
    const {
        styles = {
            button: {
                disable: {},
                active: {},
            },
        },
        label = {
            button: {
                buttonTextStep1: "",
            },
        },
        showAppLogo = true,
    } = sdkConfig;

    const age_options = [
        {
            age: "6 weeks to 11 months",
        },
        {
            age: "1 year old",
        },
        {
            age: "2 years old",
        },
        {
            age: "3 years old",
        },
        {
            age: "4 years old",
        },
        {
            age: "5 years old",
        },
        {
            age: "6 years old",
        },
        {
            age: "7 years old",
        },
        {
            age: "8 years old",
        },
        {
            age: "9 years old",
        },
        {
            age: "10 years old",
        },
        {
            age: "11 years old",
        },
        {
            age: "12 years old",
        },
        {
            age: "13 years old",
        },
        {
            age: "14 years old",
        },
        {
            age: "15 years old",
        },
        {
            age: "16 years old",
        },
        {
            age: "17 years old",
        },
        {
            age: "18 years old",
        },
        {
            age: "19 years old",
        },
        {
            age: "20 years and older",
        },
    ];

    const getPetAge = age_options.map((item, index) => {
        return { value: index.toString(), label: item.age };
    });

    const getDogBreeds = async () => {
        try {
            const { payload } = await DogBreeds.invoke({ countryCode: "US" });

            const breedMap = convertToMap(payload.payload.responses);

            setDogBreedsData(Object.values(breedMap));

            getCatBreeds();
        } catch (error) {
            logger.error("Error while fetching DOG breeds: ", error);
        }
    };

    const getCatBreeds = async () => {
        try {
            const { payload } = await CatBreeds.invoke({ countryCode: "US" });

            const breedMap = convertToMap(payload.payload.responses);

            setCatBreedsData(Object.values(breedMap));
        } catch (error) {
            logger.error("Error while fetching CAT breeds: ", error);
        }
    };

    const convertToMap = (obj) => {
        const updatedObj = obj.reduce((allValues, item) => {
            allValues[item.breedId] = { ...item, value: item.breedId };

            return allValues;
        }, {});

        return updatedObj;
    };

    const handleFormChange = (data) => {
        setFormData({ ...formData, ...data });
    };

    const handleSubmit = () => {
        console.log("ayaaa", formData);
    };

    useEffect(() => {
        getDogBreeds();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (inProcess) {
            handleSubmit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inProcess]);

    return (
        <>
            {showAppLogo && <Header />}
            <div className="conversationalForm">
                <div className="conversationalForm__container">
                    <div className="conversationalForm__container__formContainer">
                        <div className="conversationalForm__container__formContainer__img">
                            <img
                                src="https://images.prismic.io/buy-conversational-prototype/d6f5bcfb-15cc-414b-a24d-5bba4876faf6_Chatbot+Container.png?auto=compress,format"
                                alt="img"
                            />
                        </div>
                        {stepNo === 1 && (
                            <FormStep1
                                styles={styles}
                                setStepNo={setStepNo}
                                handleFormChange={handleFormChange}
                                data={{ firstName: formData.firstName, lastName: formData.lastName }}
                            />
                        )}
                        {stepNo === 2 && (
                            <FormStep2
                                styles={styles}
                                setStepNo={setStepNo}
                                handleFormChange={handleFormChange}
                                data={{ petName: formData.petName }}
                                formData={formData}
                            />
                        )}
                        {stepNo === 3 && (
                            <FormStep3
                                styles={styles}
                                setStepNo={setStepNo}
                                handleFormChange={handleFormChange}
                                data={{ petType: formData.petType }}
                                formData={formData}
                            />
                        )}
                        {stepNo === 4 && (
                            <FormStep4
                                styles={styles}
                                setStepNo={setStepNo}
                                handleFormChange={handleFormChange}
                                data={{ breedId: formData.breedId }}
                                breedData={formData.petType === "DOG" ? dogBreedsData : catBreedsData}
                                formData={formData}
                            />
                        )}
                        {stepNo === 5 && (
                            <FormStep5
                                styles={styles}
                                setStepNo={setStepNo}
                                handleFormChange={handleFormChange}
                                data={{ petAge: formData.petAge }}
                                breedData={formData.petType === "DOG" ? dogBreedsData : catBreedsData}
                                ageData={getPetAge}
                                formData={formData}
                            />
                        )}
                        {stepNo === 6 && (
                            <FormStep6
                                styles={styles}
                                setStepNo={setStepNo}
                                handleFormChange={handleFormChange}
                                data={{
                                    zipCode: formData.zipCode,
                                    isValidZip: formData.isValidZip,
                                    marketing: formData.marketing,
                                }}
                                formData={formData}
                            />
                        )}
                        {stepNo === 7 && (
                            <FormStep7
                                styles={styles}
                                buttonName={label?.button?.buttonTextStep1}
                                setStepNo={setStepNo}
                                handleFormChange={handleFormChange}
                                data={{ email: formData.email, isValidEmail: formData.isValidEmail }}
                                formData={formData}
                                inProcess={inProcess}
                                setInProcess={setInProcess}
                            />
                        )}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

ConversationalForm.propTypes = {};

export default ConversationalForm;
